module.exports = __webpack_public_path__ + "static/media/redInstagram.3878135b.svg";